import { render, staticRenderFns } from "./ErrorDisplay.vue?vue&type=template&id=63688d14&scoped=true&"
import script from "./ErrorDisplay.vue?vue&type=script&lang=js&"
export * from "./ErrorDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63688d14",
  null
  
)

export default component.exports